@if (isDisabled) {
<app-alert-card type="info" [icon]="'info'" [closable]="false">
    Como a opção "Todos os clientes" está ligada, não é necessário escolher os clientes manualmente.
</app-alert-card>
} @else {

<div class="d-flex justify-content-between align-items-center mb-3">
    <span class="small">{{ clientes.length }} cliente(s) na lista</span>
    <button type="button" mat-button class="btn-add-right" (click)="adicionarLinha()">
        <mat-icon>add</mat-icon> Adicionar cliente
    </button>
</div>

<!-- Linha de Adição -->
@if (showAddRow) {
<div class="add-row-container mb-3">
    <div class="row align-items-center">
        <div class="col-12 col-md-6">
            <app-select-pesquisavel [control]="novoClienteControl" [apiUrl]="urlCliente" label="Cliente" idField="id"
                nameField="descricao" (selectionChange)="onClienteSelecionado($event)" [subscriptSizing]="'dynamic'">
            </app-select-pesquisavel>
        </div>
        <div class="col-12 col-md-auto d-flex gap-2">
            <button type="button" mat-flat-button class="btn-primary" (click)="confirmarAdicao()">
                <mat-icon>check</mat-icon> Adicionar
            </button>
            <button type="button" mat-button (click)="cancelarAdicao()">
                <mat-icon>close</mat-icon> Cancelar
            </button>
        </div>
    </div>
</div>
}

<!-- Filtro -->
@if (clientes.length > 0) {
<div class="row">
    <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100 mb-2" subscriptSizing="dynamic">
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>Filtrar clientes</mat-label>
            <input matInput [(ngModel)]="filtroTexto" (ngModelChange)="onFilter()"
                placeholder="Buscar por nome, CPF/CNPJ...">
            @if (filtroTexto) {
            <button matSuffix mat-icon-button (click)="filtroTexto = ''; onFilter()">
                <mat-icon>close</mat-icon>
            </button>
            }
        </mat-form-field>
    </div>
</div>

}

<!-- Tabela de Clientes -->
@if (clientes.length > 0) {
<div class="table-responsive">
    <table mat-table [dataSource]="clientesVisiveis" matSort (matSortChange)="onSort($event)" class="w-100">

        <!-- Nome -->
        <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
            <td mat-cell *matCellDef="let element">{{ element.nome }}</td>
        </ng-container>

        <!-- Documento -->
        <ng-container matColumnDef="cpfCnpj">
            <th mat-header-cell *matHeaderCellDef>Documento</th>
            <td mat-cell *matCellDef="let element">{{ formatDocumento(element.cpfCnpj) }}</td>
        </ng-container>

        <!-- Ações -->
        <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let element; let i = index" class="text-center w-actions">
                <button mat-icon-button type="button" matTooltip="Remover cliente" (click)="removerCliente(i)">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
@if (hasMore) {
<div class="text-center mt-3">
    <button type="button" mat-button class="btn-ver-mais" (click)="verMais()">
        <mat-icon>expand_more</mat-icon>
        Ver mais ({{ clientesVisiveis.length }} de {{ clientes.length }})
    </button>
</div>
}
} @else {
<div class="empty-contacts">
    Nenhum cliente adicionado à lista.
</div>
}
}